require('parsleyjs');
require('parsleyjs/dist/i18n/en.js');
require('parsleyjs/dist/i18n/en.extra.js');

require("../css/validation.css");

PageLogin = {
  init: function () {
    console.log('PageLogin:init');
    // console.log($);
    // var body = $('body');
    // console.log(body);
   
    $('body')
      .on('click', '#l_fr', function (e) {
        console.log('#l_fr:click');
        e.preventDefault();
        $('#i_fr').show();
        $('#i_en').hide();
        $('#t_n_fr').show();
        $('#t_n_en').hide();
        $('#b_pwd_fr').show();
        $('#b_pwd_en').hide();
        $('#c_t_fr').show();
        $('#c_t_en').hide();
        $('#bt_s_fr').show();
        $('#bt_s_en').hide();
        $('#t_f_fr').show();
        $('#t_f_en').hide();
        $('#bt_fp_fr').show();
        $('#bt_fp_en').hide();
        $('#b_login_fr').show();
        $('#b_login_en').hide();
        $(this).addClass('active');
        $('#l_en').removeClass('active');
      })
      .on('click', '#l_en', function (e) {
        console.log('#l_en:click');
        e.preventDefault();
        $('#i_fr').hide();
        $('#i_en').show();
        $('#t_n_fr').hide();
        $('#t_n_en').show();
        $('#b_pwd_fr').hide();
        $('#b_pwd_en').show();
        $('#c_t_fr').hide();
        $('#c_t_en').show();
        $('#bt_s_fr').hide();
        $('#bt_s_en').show();
        $('#t_f_fr').hide();
        $('#t_f_en').show();
        $('#bt_fp_fr').hide();
        $('#bt_fp_en').show();
        $('#b_login_fr').hide();
        $('#b_login_en').show();
        $(this).addClass('active');
        $('#l_fr').removeClass('active');
      })
      .on('click', '#b_pwd_fr,#b_pwd_en', function (e) {
        console.log('#b_pwd_fr:click');
        e.preventDefault();
        $('#d_login').hide();
        $('#d_pwd').show();
      })
      .on('click', '#b_login_fr,#b_login_en', function (e) {
        console.log('#b_login:click');
        e.preventDefault();
        $('#d_login').show();
        $('#d_pwd').hide();
      })
      .on('click', '#btn_pwd', function (e) {
        console.log('#btn_pwd:click');
        e.preventDefault();
        var $form = $('#form_pwd');
        console.log($form.attr('action'));
        // if ($form.parsley().validate()) {
        $.post($form.attr('action'), $form.serialize(), function (response) {
          if (typeof response.message !== 'undefined') {
            new PNotify({
              title: response.message.title,
              type: response.message.type,
              text: response.message.text,
              hide: false
            });
          }
          // // window.location.href = '/';
          // $('#bt_submit').hide();
          // $('input, select, textarea').prop('disabled', true);
        })
        // }
      })
  }
};

PageLogin.init();



//////////////////
// WEBPACK FOOTER
// ./revo_assets/admin/js/login.js
// module id = 407
// module chunks = 12